import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { FileText, FolderOpen } from "lucide-react";
import { Button } from "../ui/button";
import { FileManager } from "@cubone/react-file-manager";
import "./files.css";
import PolicyManagement from "./PolicyManagement";
import { getFiles, createFolder, renameFile, deleteFile, getFilesByCompliance , renameFileCompliance, createFolderCompliance} from "../../store/actions/filesActions";
import { useFileManagerDomI18n } from "./useFileManagerDomI18n";

function Files(props) {
    const { t, i18n } = useTranslation();
    const fileManagerRootRef = useRef(null);
    const { token, getFilesFN, getFilesByComplianceFN, files, createFolderFN, renameFileFN, deleteFileFN, department_id, compliance_id, isComp, renameFileComplianceFN, createFolderComplianceFN } = props;
    const [currentPage, setCurrentPage] = useState('policies');
    const [forceReRender, setForceReRender] = useState(false);
    const [currentPath, setCurrentPath] = useState("/");

    useFileManagerDomI18n(fileManagerRootRef, currentPage === "files" && forceReRender);

   const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";

  useEffect(() => {
    if (isComp) {
      if (currentPage === 'files' && compliance_id) {
        getFilesByComplianceFN(compliance_id);
      }

    } else {
      if (currentPage === 'files' && department_id) {
        getFilesFN(department_id);
      }
    }
  }, [department_id, currentPage, getFilesFN, compliance_id, getFilesByComplianceFN]);

  useEffect(() => {
    if (currentPage === 'files') {
      setForceReRender(false);
            setTimeout(() => {
                setForceReRender(true);
            }, 100);
        }
    }, [files, currentPage]);

    const onFileOpen = (file) => {
        if (file.isDirectory) {
            return setCurrentPath(file.path);
        }
        window.open(file.s3_path, '_blank');
    };

    const onDownload = (files) => {
        for (let file of files) {
            window.open(file.s3_path, '_blank');
        }
    };

    const onDelete = (files) => {
        for (let file of files) {
            deleteFileFN(file.id, department_id);
        }
    };

  const handleGet = () => {
    if (isComp) {
      getFilesByComplianceFN(compliance_id);
    } else {
      getFilesFN(department_id);
    }
  };


  const create_folder = (folderName) => {
    if(isComp){
      createFolderComplianceFN(folderName, currentPath, compliance_id)
    }else{
      createFolderFN(folderName, currentPath, department_id)
    }
  };

  const rename_file = (file, newName) => {
    if (isComp) {
      renameFileComplianceFN(file, newName, compliance_id)
    } else {

      renameFileFN(file, newName, department_id)
    }
  };


  const fileUploadConfig = {
    url: API_URL + "/api/files/add_file",
    headers: {
      Authorization: token,
      current_folder: currentPath || "/",
      ...(isComp
        ? { compliance_id: String(compliance_id) || "1" }
        : { department_id: String(department_id) || "1" }),
    },
  };

  //console.log("fileUploadConfig ", fileUploadConfig)



return (
  <div className="h-dvh flex flex-col bg-background overflow-hidden bg-[#F8F8F8]">
    {/* scroll area */}
    <div className="flex-1 min-h-0 overflow-y-auto bg-[#F8F8F8]">
      {/* ✅ shared spacing contract (both pages) */}
      <div className="px-6 md:px-10 xl:px-16 2xl:px-24 pt-5 md:pt-5 pb-40">

        {currentPage === "policies" && (
          <PolicyManagement isComp={isComp} setCurrentPage={setCurrentPage} />
        )}

        {currentPage === "files" && (
          <div className="min-h-0">
            {/* Header row */}
            <div className="mb-6">
              <div className="flex justify-between items-start">
                <div>
                  <h1 className="text-2xl font-semibold mb-2">{t('policyManagement.tabs.fileManagement')}</h1>
                  <p className="text-muted-foreground">
                    {t("fileManager.subtitle")}
                  </p>
                </div>

                <nav className="flex gap-2">
                  <Button
                    variant="ghost"
                    onClick={() => setCurrentPage("policies")}
                  >
                    <FileText className="mr-2 h-4 w-4" />
                    {t('policyManagement.tabs.policyManagement')}
                  </Button>

                  <Button
                    variant="default"
                    onClick={() => setCurrentPage("files")}
                  >
                    <FolderOpen className="mr-2 h-4 w-4" />
                    {t('policyManagement.tabs.fileManagement')}
                  </Button>
                </nav>
              </div>
            </div>



            {forceReRender && (
              <div ref={fileManagerRootRef} className="min-h-0">
                <FileManager
                  key={i18n.language}
                  onFileUploaded={() => handleGet()}
                  files={files}
                  enableFilePreview={false}
                  fileUploadConfig={fileUploadConfig}
                  onCreateFolder={(folderName) => create_folder(folderName)}
                  onRefresh={() => handleGet()}
                  onFileOpen={onFileOpen}
                  onDownload={onDownload}
                  onRename={(file, newName) => rename_file(file, newName)}
                  onDelete={onDelete}
                />
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  </div>
);



}

const mapStateToProps = (state) => {
    ////console.log("Files", state.files)
    return {

        token: state.auth.token,
        files: state.files?.files



    };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFilesFN: (d) => dispatch(getFiles(d)),
    getFilesByComplianceFN: (c) => dispatch(getFilesByCompliance(c)),
    createFolderFN: (folderName, currentFolder, d) => dispatch(createFolder(folderName, currentFolder, d)),
    createFolderComplianceFN: (folderName, currentFolder, c) => dispatch(createFolderCompliance(folderName, currentFolder, c)),
    renameFileFN: (file, newName, d) => dispatch(renameFile(file, newName, d)),
    renameFileComplianceFN: (file, newName, c) => dispatch(renameFileCompliance(file, newName, c)),
    deleteFileFN: (id, d) => dispatch(deleteFile(id, d))

  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Files);
